import $ from 'jquery';
import { fabric } from 'fabric';
import { enableTooltips, jsUcfirst, changeObjectProperty } from './utils';
import {
  triggerStateChangedRequest,
  triggerStateChangedRequestDebounced,
  generateObjRefId,
} from '~core';
import { removeBackground, toggleEditorSidebar } from '~src/sidebarLegacy';
import { editorConfig } from '~config';
import { addCanvasImage } from '~core/image';
import { getState, modifyState } from '~src/state';
import { handleAfPhotoSelection } from '~src/sidebar/annunciFunebri';
import {
  handleMagicFramePhotoSelection,
  handleMagicFrameBackgroundSelection,
  showMagicFrameCustomControls,
} from '~core/magicFrame';
import { hideAllMenus } from '~core/hideAllMenus';
import { generateCurrentPageThumbnail, goToPage } from '~src/multipages';
import Swal from 'sweetalert2';

const setCanvasBackground = (imageUrl) => {
  return new Promise((resolve) => {
    window.canvas.setBackgroundImage(
      '',
      window.canvas.renderAll.bind(window.canvas),
      {}
    );

    if (imageUrl) {
      fabric.Image.fromURL(
        imageUrl,
        (image) => {
          image.set({
            crossOrigin: 'anonymous',
            giotto: {
              objRefId: generateObjRefId('image'),
            },
          });

          window.canvas.setBackgroundImage(
            image,
            window.canvas.renderAll.bind(window.canvas),
            {
              scaleX: window.canvas.width / image.width,
              scaleY: window.canvas.height / image.height,
              originX: 'left',
              originY: 'top',
              crossOrigin: 'anonymous',
              erasable: false,
            }
          );

          triggerStateChangedRequest();
          $('.editor-sidebar-image-injection-loader').remove();

          resolve(image);
        },
        { crossOrigin: 'anonymous' }
      );
    }
  });
};

/**
 * Filters
 */
function onFilterClick(event) {
  const filterName = $(event.currentTarget).data('filter');
  let activeObject = getState('activeObject');
  if (activeObject.type === 'MagicFrame') {
    activeObject = activeObject.editingImg;
    if (!activeObject) {
      return;
    }
  }

  if (filterName === 'remove-all') {
    // Clear all filters
    activeObject.filters = [];
  } else {
    const filterConfig = editorConfig.filters.find(
      (filter) => filter.name === filterName
    );

    if (filterConfig) {
      // Create new filter
      const newFilter = filterConfig.filterFunc();

      // Set the type if not automatically set by the filter constructor
      if (filterConfig.type && !newFilter.type) {
        newFilter.type = filterConfig.type;
      }

      // For basic filters, we replace all filters
      // This is the expected behavior for the basic filter presets
      activeObject.filters = [newFilter];
    }
  }

  activeObject.applyFilters();
  window.canvas.renderAll();

  triggerStateChangedRequest();
}

function updateImageFiltersButtons() {
  let activeObject = getState('activeObject');
  if (activeObject.type === 'MagicFrame') {
    activeObject = activeObject.editingImg;
    if (!activeObject) {
      return;
    }
  }

  const { cacheKey, opacity } = activeObject;

  if (opacity) {
    $('[data-filter="opacity"]').val(opacity);
  }

  const gammaFilter = activeObject.filters
    ? activeObject.filters.find(
        (filter) => filter && typeof filter === 'object' && 'gamma' in filter
      )
    : null;

  if (gammaFilter) {
    const { gamma } = gammaFilter;
    $('[data-filter="red"]').val(gamma[0]);
    $('[data-filter="green"]').val(gamma[1]);
    $('[data-filter="blue"]').val(gamma[2]);
  } else {
    $('[data-filter="red"]').val(1);
    $('[data-filter="green"]').val(1);
    $('[data-filter="blue"]').val(1);
  }

  // Update advanced filter values based on finding filters by type
  for (const filterConfig of editorConfig.advancedFilters) {
    if (!activeObject.filters || activeObject.filters.length === 0) {
      // set to default value
      if (filterConfig.type === 'Exposure') {
        $(`[data-filter="${filterConfig.name}"]`).val(0);
      } else if (filterConfig.type === 'ShadowBoost') {
        $(`[data-filter="${filterConfig.name}"]`).val(0);
      } else if (filterConfig.type === 'Brightness') {
        $(`[data-filter="${filterConfig.name}"]`).val(0);
      } else if (filterConfig.type === 'Contrast') {
        $(`[data-filter="${filterConfig.name}"]`).val(0);
      } else if (filterConfig.type === 'Saturation') {
        $(`[data-filter="${filterConfig.name}"]`).val(0);
      } else if (filterConfig.type === 'Blur') {
        $(`[data-filter="${filterConfig.name}"]`).val(0);
      }
      continue;
    }

    const filter = activeObject.filters.find(
      (f) => f && f.type === filterConfig.type
    );

    if (!filter) {
      continue;
    }

    // Extract the filter value based on its type
    let currentVal;
    switch (filterConfig.type) {
      case 'Exposure':
        currentVal = filter.exposure;
        break;
      case 'ShadowBoost':
        currentVal = filter.shadowBoost;
        break;
      case 'Brightness':
        currentVal = filter.brightness;
        break;
      case 'Contrast':
        currentVal = filter.contrast;
        break;
      case 'Saturation':
        currentVal = filter.saturation;
        break;
      case 'Blur':
        currentVal = filter.blur;
        break;
      default:
        continue;
    }

    $(`[data-filter="${filterConfig.name}"]`).val(currentVal);
  }

  const hasCache = getState(`filtersCache[${cacheKey}]`);

  $('.editor-filters-cache').hide();

  if (hasCache) {
    $(`#editor-filters-${cacheKey}`).show();
    return;
  }

  const cacheDiv = document.createElement('div');
  cacheDiv.id = `editor-filters-${cacheKey}`;
  cacheDiv.className = 'editor-filters-cache filters-grid';
  $('#editor-filters').append(cacheDiv);

  for (let filter of editorConfig.filters) {
    const miniCanvasObject = document.createElement('canvas');
    miniCanvasObject.id = `canvas-filter-${filter.name}-${cacheKey}`;

    const prettyFilterName =
      filter.name === 'remove-all' ? 'Originale' : jsUcfirst(filter.name);

    $(cacheDiv).append(
      `<div
                class="editor-filter-btn image-square" id="editor-filters-${filter.name}-${cacheKey}-container"
                data-filter="${filter.name}"
                data-toggle="tooltip" data-placement="bottom" title="${prettyFilterName}"
                >
                <div class="editor-minicanvas-prevent-click"></div>
            </div>`
    );

    enableTooltips();

    $(`#editor-filters-${filter.name}-${cacheKey}-container`).append(
      miniCanvasObject
    );

    const miniCanvas = new fabric.Canvas(miniCanvasObject.id, {
      hoverCursor: 'pointer',
      selection: false,
      width: 100,
      height: 100,
    });

    const imageUrl = activeObject.getSrc();

    fabric.Image.fromURL(
      imageUrl,
      function (image) {
        if (image.width > image.height) {
          image.scaleToHeight(100);
        } else {
          image.scaleToWidth(100);
        }

        // Center the image
        image.set({
          left: miniCanvas.width / 2,
          top: miniCanvas.height / 2,
          originX: 'center',
          originY: 'center',
        });

        if (filter.filterFunc) {
          // Create a new filters array with just this filter
          const newFilter = filter.filterFunc();
          // Set the type if not automatically set by the filter constructor
          if (filter.type && !newFilter.type) {
            newFilter.type = filter.type;
          }
          image.filters = [newFilter];
        }

        miniCanvas.add(image);
        image.applyFilters();
      },
      { crossOrigin: 'anonymous' }
    );
    miniCanvas.renderAll();
  }

  $('body').off('click', 'div[data-filter]');
  $('body').on('click', 'div[data-filter]', onFilterClick);

  modifyState(`filtersCache.${cacheKey}`, true);
}

function onObjectImageSelected() {
  hideAllMenus();
  $('#editor-menu-object').show();

  updateImageFiltersButtons();
  // TODO: fix following ==> setCurrentFilters();

  // Hide non-image sidebar
  const isSidebarOpen = getState('isSidebarOpen');
  if (isSidebarOpen && $('.tab.active').length) {
    const tabObjectType = $('.tab.active').first().data('object-type');
    if (tabObjectType !== 'image' && tabObjectType !== 'eraser') {
      toggleEditorSidebar();
    }
  }

  if (window.canvas.getActiveObject()._magicFrame) {
    showMagicFrameCustomControls();
  }
}

function handleRgbFilter(filterName, value) {
  let red = parseFloat(
    document.getElementById('editor-filter-red-slider').value
  );
  let green = parseFloat(
    document.getElementById('editor-filter-green-slider').value
  );
  let blue = parseFloat(
    document.getElementById('editor-filter-blue-slider').value
  );

  // filterName is either red, green, blue and it should override the value
  if (filterName === 'red') {
    red = value;
  } else if (filterName === 'green') {
    green = value;
  } else if (filterName === 'blue') {
    blue = value;
  }

  let image = getState('activeObject');
  if (image.type === 'MagicFrame') {
    image = image.editingImg;
  }

  // Create a new gamma filter
  const newGammaFilter = new fabric.Image.filters.Gamma({
    gamma: [red, green, blue],
    type: 'Gamma',
  });

  // Find if a gamma filter already exists
  const gammaFilterIndex = image.filters.findIndex(
    (filter) => filter && typeof filter === 'object' && 'gamma' in filter
  );

  if (gammaFilterIndex >= 0) {
    // Replace existing gamma filter
    image.filters[gammaFilterIndex] = newGammaFilter;
  } else {
    // Add new gamma filter
    image.filters.push(newGammaFilter);
  }

  image.applyFilters();
  window.canvas.renderAll();
}

function onFilterValueChange(event) {
  const activeObject = getState('activeObject');
  if (!activeObject) {
    return;
  }
  const filterName = $(event.currentTarget).data('filter');
  const value = $(event.currentTarget).val();
  $(`#editor-filter-${filterName}-value`).val(Math.round(value * 100) / 100);

  const isMagicFrame = activeObject.type === 'MagicFrame';
  if (isMagicFrame && filterName === 'opacity') {
    Swal.fire({
      title: 'Attenzione',
      text:
        "Nelle cornici magiche non è possibile modificare l'opacità della foto del defunto",
      icon: 'warning',
      confirmButtonText: 'OK',
    });
    return;
  }

  const isRgbFilter =
    filterName.includes('red') ||
    filterName.includes('green') ||
    filterName.includes('blue');

  const filterConfig = editorConfig.advancedFilters.find(
    (advancedFilter) => advancedFilter.name === filterName
  );

  if (isRgbFilter) {
    handleRgbFilter(filterName, value);
  } else if (filterConfig) {
    let image = getState('activeObject');
    if (image.type === 'MagicFrame') {
      image = image.editingImg;
    }

    // Find if the filter of this type already exists
    const filterIndex = image.filters.findIndex(
      (f) => f && f.type === filterConfig.type
    );

    if (filterIndex >= 0) {
      // Replace existing filter
      image.filters[filterIndex] = filterConfig.filterFunc(value);
    } else {
      // Add new filter
      image.filters.push(filterConfig.filterFunc(value));
    }

    image.applyFilters();
    window.canvas.renderAll();
  } else {
    changeObjectProperty(filterName, value);
  }

  triggerStateChangedRequestDebounced();
}

function onFilterTextValueChange(event) {
  const filterName = $(event.currentTarget).data('filter');
  const value = $(event.currentTarget).val();
  $(`#editor-filter-${filterName}-value`).val(value);

  const filterConfig = editorConfig.advancedFilters.find(
    (advancedFilter) => advancedFilter.name === filterName
  );

  $(`#editor-filter-${filterName}-slider`).val(value);

  const image = getState('activeObject');

  // Find if the filter of this type already exists
  const filterIndex = image.filters.findIndex(
    (f) => f && f.type === filterConfig.type
  );

  if (filterIndex >= 0) {
    // Replace existing filter
    image.filters[filterIndex] = filterConfig.filterFunc(value);
  } else {
    // Add new filter
    image.filters.push(filterConfig.filterFunc(value));
  }

  image.applyFilters();
  window.canvas.renderAll();

  triggerStateChangedRequest();
}

export const sidebarImageInjectionLoader =
  '<div class="editor-sidebar-image-injection-loader"><div class="spinner-grow" role="status"><span class="sr-only">Caricamento...</span></div></div>';

const onAddLogoToCanvas = async (event) => {
  event.preventDefault();
  const url = $(event.currentTarget).data('url');
  const logoType = $(event.currentTarget).data('logo-type');

  const options = {
    giotto: {
      objRefId: generateObjRefId('logo'),
      logo: true,
      logoType,
    },
  };

  $(event.currentTarget).append(sidebarImageInjectionLoader);
  await addCanvasImage(url, options);
};

const onAddImageToCanvas = async (event) => {
  event.preventDefault();
  const url = $(event.currentTarget).data('url');

  if (getState('magicFrameSelectPersonPhotoActive')) {
    await handleMagicFramePhotoSelection(url);
    return;
  }

  if (getState('afSelectPhotoActive')) {
    handleAfPhotoSelection(url);
    return;
  }

  $(event.currentTarget).append(sidebarImageInjectionLoader);
  await addCanvasImage(url);
};

const onSetCanvasBackground = async (url) => {
  if (getState('magicFrameSelectBackgroundPhotoActive')) {
    await handleMagicFrameBackgroundSelection(url);
    return;
  }

  removeBackground();

  let image;
  const isSvg = url.endsWith('.svg');

  if (
    !isSvg &&
    document.getElementById('switch-background-application-mode').checked
  ) {
    await setCanvasBackground(url);
  } else {
    image = await addCanvasImage(url);
  }

  if (isSvg) {
    image.set({
      top: 0,
      left: 0,
      lockMovementX: true,
      lockMovementY: true,
      lockScalingX: true,
      lockScalingY: true,
      lockRotation: true,
      selectable: true,
      editable: false,
      giotto: {
        objRefId: generateObjRefId('background'),
        isBackground: true,
      },
    });

    image.scaleToHeight(window.canvas.height);
    image.set('width', window.canvas.width);
    // image.scaleX = 1;
    // image.scaleX = 1;
    window.canvas.sendToBack(image);
    window.canvas.renderAll();
    triggerStateChangedRequest();
  }
};

const startLoader = () => {
  $('.canvas-container').hide();
  $('.app-spinner').show();
  Swal.fire({
    title: 'Applicando sfondo',
    allowOutsideClick: false,
    allowEscapeKey: false,
    allowEnterKey: false,
    showConfirmButton: false,
    confirmButtonColor: '#278e8e',
    didOpen: () => {
      Swal.showLoading();
    },
  });
};

const stopLoader = () => {
  $('.canvas-container').show();
  $('.app-spinner').hide();
  Swal.fire({
    title: 'Fatto!',
    icon: 'success',
    showCloseButton: true,
    confirmButtonColor: '#278e8e',
    didOpen: () => {
      Swal.hideLoading();
    },
  });
};

const onBackgroundChange = async (event) => {
  event.preventDefault();

  const url = $(event.currentTarget).data('url');

  const projectType = getState('selected.tipo');
  const isCordogli = editorConfig.cordogliProjectIds.includes(
    projectType.objectId
  );

  if (isCordogli) {
    startLoader();
    const currentPages = getState('pages');
    for (let i = 0; i < currentPages.length; i++) {
      await goToPage(i);
      await onSetCanvasBackground(url);
      await generateCurrentPageThumbnail();
    }
    stopLoader();
  } else {
    onSetCanvasBackground(url);
  }
};

export {
  onAddImageToCanvas,
  onFilterTextValueChange,
  onFilterValueChange,
  onObjectImageSelected,
  onSetCanvasBackground,
  setCanvasBackground,
  addCanvasImage,
  onAddLogoToCanvas,
  onBackgroundChange,
};
